/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_3_QInputs */

const en_mk_tut_tr_3_q = /** @type {(inputs: Mk_Tut_Tr_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentioning an agent with @ does not summon it.`)
};

const id_mk_tut_tr_3_q = /** @type {(inputs: Mk_Tut_Tr_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyebut agen dengan @ tidak memanggilnya.`)
};

/**
* | output |
* | --- |
* | "Mentioning an agent with @ does not summon it." |
*
* @param {Mk_Tut_Tr_3_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_3_q = /** @type {((inputs?: Mk_Tut_Tr_3_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_3_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_3_q(inputs)
	return en_mk_tut_tr_3_q(inputs)
});